module.exports = __webpack_public_path__ + "98b05b5a1d68509a442ba87af4c3d59e.png";